// First-run tooltip carousel. Stored in localStorage; once dismissed, gone.

import { useRef, useState } from "react";
import { useDialog } from "./useDialog";

const STEPS: { title: string; body: string }[] = [
  {
    title: "Welcome to the war room",
    body: "Breakpoint is a 10-turn race. Identify the 4 hidden attack-chain cards before time runs out — and before the other teams.",
  },
  {
    title: "Each turn, play one Procedure",
    body: "Click a card. The server rolls a d20: 11+ to hit. The 4 'established' procedures (marked +3 EST) get a +3 bonus. Used cards cool down for 4 turns.",
  },
  {
    title: "Talk to your team",
    body: "There's a chat panel. Real incident response is talking — who saw what, who calls legal, who briefs the CEO. The injects test that, not just the dice.",
  },
];

const FLAG = "breakpoint.onboarded.v1";

export function Onboarding({ onDismiss }: { onDismiss: () => void }) {
  const seen = (() => {
    try { return localStorage.getItem(FLAG) === "1"; } catch { return true; }
  })();
  const [step, setStep] = useState(0);
  const dialogRef = useRef<HTMLDivElement>(null);
  const close = () => {
    try { localStorage.setItem(FLAG, "1"); } catch { /* ignore */ }
    onDismiss();
  };
  useDialog(dialogRef, close);
  if (seen) return null;
  const last = step === STEPS.length - 1;
  const cur = STEPS[step]!;
  return (
    <div className="modal-backdrop" onClick={close}>
      <div
        className="modal"
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-label="Getting started"
        style={{ maxWidth: 480 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-body">
          <div
            style={{
              fontFamily: "var(--font-mono)",
              fontSize: 11,
              letterSpacing: "0.18em",
              color: "var(--color-accent)",
              textTransform: "uppercase",
              marginBottom: 6,
            }}
          >
            Brief · {step + 1} / {STEPS.length}
          </div>
          <h2 style={{ margin: "0 0 12px", fontSize: 22 }}>{cur.title}</h2>
          <p style={{ fontSize: 14, lineHeight: 1.6 }}>{cur.body}</p>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 22 }}>
            <button onClick={close}>Skip</button>
            {last ? (
              <button className="primary" onClick={close}>Got it</button>
            ) : (
              <button className="primary" onClick={() => setStep(step + 1)}>Next →</button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
